import React from 'react';
import { motion } from 'framer-motion';
import SectionShell from './Chapter';
import { SITE } from '@/constants/testIds';

const PHASES = [
  {
    n: '01',
    title: 'Diagnostic',
    body:
      'A short, senior-led review of the situation, the objective and the counterparty universe. Direct honesty about what will and will not work.',
  },
  {
    n: '02',
    title: 'Mandate framing',
    body:
      'Scope, timeline, success measures and fee construct — designed around a definable outcome rather than an open-ended retainer.',
  },
  {
    n: '03',
    title: 'Positioning & materials',
    body:
      'A precise investment narrative, information memorandum and process artefacts — built for decision-makers, not paginated for effect.',
  },
  {
    n: '04',
    title: 'Counterparty engagement',
    body:
      'Curated, sequenced outreach to strategic and financial counterparties across India, MENA and Hong Kong. No blanket teasers.',
  },
  {
    n: '05',
    title: 'Negotiation & structuring',
    body:
      'Term-sheet negotiation, deal structuring, diligence coordination and shareholder alignment — driven from the partner level throughout.',
  },
  {
    n: '06',
    title: 'Close & continuity',
    body:
      'Documentation, closing mechanics and a handover the client can operate from Day 1. Post-close continuity when the relationship warrants it.',
  },
];

export const Approach = () => {
  const ease = [0.22, 1, 0.36, 1];
  return (
    <SectionShell
      id="approach"
      testId={SITE.approach}
      theme="light"
      index="05"
      eyebrow="How We Work"
      title={
        <>
          A tight, six-phase process — designed to shorten the distance between
          a mandate and a close.
        </>
      }
      intro="Every engagement follows the same disciplined arc. Nothing is delegated to a name the client hasn't met."
    >
      <ol className="border-t border-[color:var(--rule-light)]">
        {PHASES.map((p, i) => (
          <motion.li
            key={p.n}
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-10% 0px' }}
            transition={{ duration: 0.7, delay: i * 0.05, ease }}
            className="grid grid-cols-12 gap-6 md:gap-10 py-8 md:py-10 border-b border-[color:var(--rule-light)]"
          >
            <div className="col-span-3 md:col-span-1">
              <span className="font-serif text-[26px] leading-none text-[color:var(--gold-3)]">
                {p.n}
              </span>
            </div>
            <div className="col-span-9 md:col-span-4">
              <h3 className="font-serif text-[22px] md:text-[26px] leading-[1.15] tracking-[-0.01em] text-[color:var(--charcoal)]">
                {p.title}
              </h3>
            </div>
            <div className="col-span-12 md:col-span-7">
              <p className="text-[15px] leading-[1.65] text-[color:var(--charcoal-2)] max-w-[540px]">
                {p.body}
              </p>
            </div>
          </motion.li>
        ))}
      </ol>
    </SectionShell>
  );
};

export default Approach;
